module.exports = __webpack_public_path__ + "static/media/chicken_shield.60cf3036.png";